import { BaseService } from "./common/base";

export class UploadService extends BaseService<any> {
  constructor() {
    super("upload");
  }

  create(data: unknown): Promise<any> {
    return this.api
      .post(`/`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
  }

  download(id, opts = {}): Promise<any> {
    return this.api
      .get(`/`, {
        params: {
          key: id,
        },
        ...opts,
      })
      .then((res) => res.data);
  }
}
